Button = require 'components/common/button'
Translation = require 'components/mixins/translation'

DeleteButton = createReactClass
  displayName: 'DeleteButton'

  mixins: [Translation()]

  propTypes:
    onClick: PropTypes.func.isRequired
    title: PropTypes.string

  render: ->
    title = @props.title ? @i18n 'actions.delete'
    classes = classNames "delete", @props.className
    <Button className={classes} title={title} onClick={@props.onClick}/>

module.exports = DeleteButton
